import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import useFetchWithCancellation from "../../../customhooks/useFetchWithCancellation";
import { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button, Spinner, Modal, CloseButton } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../controls/Icons/Icon";

export default function AddCoordinator({ _selectedfms, selectedfmsName, coordinatorId, servicetypeId, afterSave }) {
    const [Loading, setLoading] = useState(true);
    const [validated, setValidated] = useState(false);
    const formRef = useRef(null);
    const phonenumberRef = useRef(null);
    const [errMsg, seterrMsg] = useState("");
    const [emailErrmsg, setemailErrmsg] = useState("");
    const { fetchData } = useFetchWithCancellation();
    const state = useSelector(state => state);
    const [touched, setTouched] = useState(false);
   
    useEffect(() => {
        setLoading(false);
    }, [])
    const [inputValue, setInputValue] = useState({
        firstName: "",
        lastName:"",
        phoneNumber: "",
        email: "",
        fkServiceTypeID: servicetypeId,
        fmsregcareId:coordinatorId
      //  coordinatorType: coordinatorType
    });
    const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (e.target.type === "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        if (name === "phoneNumber") {
            seterrMsg("");
            //if (isNaN(value)) {
            //    e.target.value = "";
            //    return false;
            //}
        }

        //email
        //if (name === "email") {
        //    if (!validateEmail(value)) {
        //       // e.target.value = "";
        //        return false;
        //    }
        //}
        setInputValue(c => ({ ...c, [name]: value }));
        //dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
          });
   
    const SaveData = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (formRef.current.checkValidity() === false) {
            setValidated(true);
        }
        else {
            if (!validateEmail(inputValue.email)) {
                setemailErrmsg("Email id is invalid");
                //seterrMsg("Email id is invalid");
                return false;
            }
            if (inputValue.phoneNumber) {
                let mobileNumber = inputValue.phoneNumber;
               // setLoading(true);
               // fetchData(state.projectdetail.API + "/Coordinator/GetAll?type=4", {
                fetchData(state.projectdetail.API + "/Coordinator/isMobileNumberNumberExist?mobileNumber="
                    + mobileNumber + "&&fkServiceTypeId=" + servicetypeId
                    + "&&fmsregcareId=" + coordinatorId, {
                    method: "Get"
                }).then(response => response.json()).then((res) => {
                    if (res) {
                        seterrMsg("Mobile number already exists. Please provide a different mobile number.");
                        // setLoading(false);
                       // document.getElementsByName("phoneNumber").focus();
                        // formRef.current.phoneNumber.validated = false;
                        phonenumberRef.current.focus();
                        return false;
                    }
                    else {
                        seterrMsg("");
                        savedatatoDb(inputValue);
                    }
                }).catch((err) => {
                    if (err && err.name === 'AbortError') return;
                    window.HandleError("PCPPersonalData.js ==> client Get", null, null, err);
                    console.log(err)
                }).finally(() => {
                    setLoading(false);
                });

            }

            return true;

        }
    }

    const savedatatoDb = (inputValue) => {

        fetchData(state.projectdetail.API + "/Coordinator/save", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(inputValue)
        }).then(response => response.json()).then((res) => {
            if (res) {
                window.toast("Client saved sucessfully");
                setValidated(false);
                afterSave(servicetypeId,res);
                return true;
            }
            else {
                window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            }
        }).catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.HandleError("PCPPersonalData.js ==> client Get", null, null, err);
            console.log(err)
        }).finally(() => {
            //setLoading(false);
        });
    }
    const handleCancel = () => {
        setInputValue(inputValue => ({ ...inputValue, firstName: "", lastName: "", phoneNumber: "", email: "" }));
        formRef.current.reset();

    }
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.(com|net|in|org|edu|gov|us|uk|co\.us)$/i;
        return regex.test(email);
    };
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
        {Loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> :
            //<div> Add FMS Coordinator Page
            //    <div> Selected FMS : {_selectedfms}</div>
            //    <div> Selected FMS Name : {selectedfmsName}</div>

            <div>

                <Row className="mb-2">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>First Name<code className='required-symbol'>*</code></Form.Label>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                                <Form.Control required type="text" name="firstName" id="firstName" onChange={(e)=>handleChange(e)} autoComplete="off" />
                                <Form.Control.Feedback type="invalid">Please provide first Name</Form.Control.Feedback>
                            {/*<Form.Control.Feedback type="invalid">Please provide FMS-Service Co-ordinator's' name</Form.Control.Feedback>*/}
                            {/*{validated && !inputValue.fkfmsid && <small className="text-danger"> Please provide FMS - Service Co - ordinator's' name  </small>}*/}
                        </Form.Group>
                    </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Last Name<code className='required-symbol'>*</code></Form.Label>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Control required type="text" name="lastName" id="lastName" onChange={(e) => handleChange(e)} autoComplete="off" />
                                <Form.Control.Feedback type="invalid">Please provide last Name</Form.Control.Feedback>
                                {/*<Form.Control.Feedback type="invalid">Please provide FMS-Service Co-ordinator's' name</Form.Control.Feedback>*/}
                                {/*{validated && !inputValue.fkfmsid && <small className="text-danger"> Please provide FMS - Service Co - ordinator's' name  </small>}*/}
                            </Form.Group>
                        </Col>
                    </Row>
                <Row className="mb-2">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Mobile Number<code className='required-symbol'>*</code>
                            </Form.Label>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            {/*<PhoneInput required*/}
                            {/*    placeholder="Enter phone number"*/}
                            {/*    inputComponent={Form.Control}*/}
                            {/*    value={inputValue.MobileNumber}*/}
                            {/*    name="MobileNumber"*/}
                            {/*    id="MobileNumber"*/}
                            {/*        onChange={(val) => { handlePhoneNumberChange(val, "MobileNumber") }}*/}
                                
                            {/*/>*/}
                                <Form.Control required type="text" ref={phonenumberRef} name="phoneNumber" id="phoneNumber" onChange={(e) => handleChange(e)} autoComplete="off" />
                                {validated && !inputValue.phoneNumber && <small className="text-danger">Please provide mobile number</small>}
                                {inputValue.phoneNumber && isNaN(inputValue.phoneNumber) &&  <small className="text-danger"> Invalid Mobile Number</small>}
                                {inputValue.phoneNumber && inputValue.phoneNumber.length !== 10 && <small className="text-danger"> Invalid Mobile Number</small>}
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Email<code className='required-symbol'>*</code></Form.Label>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                                {/*<Form.Control required type="email"  name="email" id="email" onChange={(e) => handleChange(e)} autoComplete="off" />*/}
                                {/*<Form.Control.Feedback type="invalid">Please provide Email</Form.Control.Feedback>*/}
                                {/*{!validateEmail(inputValue.email) && (*/}
                                {/*    <Form.Control.Feedback type="invalid">Please provide Valid Email</Form.Control.Feedback>*/}
                                {/*)}*/}

                                <Form.Control
                                    type="text"
                                    required
                                    value={inputValue.email}
                                    name="email"
                                    onChange={(e) => handleChange(e)}
                                    onBlur={() => setTouched(true)}
                                    isValid={touched && validateEmail(inputValue.email)}
                                    isInvalid={touched && !validateEmail(inputValue.email)}
                                />

                                <Form.Control.Feedback type="invalid">
                                    Please provide valid email
                                </Form.Control.Feedback>
                               

                        </Form.Group>
                    </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label><code className='required-symbol'></code></Form.Label>
                            </Form.Group>
                        </Col>
                        
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label style={{color:'red'}}>{errMsg}</Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                <Row>
                    <Col md={6}></Col>
                    <Col md={6}>
                        <Button variant="primary" type="button" onClick={handleCancel} className="float-end me-2">
                            Clear
                        </Button>
                        &nbsp;&nbsp;
                            <Button variant="primary" type="button" onClick={(e) => SaveData(e, 3)} disabled={Loading} className="float-end me-2">
                            Save
                        </Button>
                    </Col>

                </Row>

            </div>

        }
        </Form>
    </ErrorBoundary>


    )
}